export enum DeliveryModeKind {
    Both = -1,
    Pickup = 0,
    Deliver = 1,
    UseDefaultSetting = 2
}
